<div class="mx-auto" *ngIf="isGraphLoading">
    <span class="fa fa-spinner fa-pulse fa-3x" aria-label="Processing"></span>
</div>
<div id="graphDiv"></div>
